import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../RoutingAuth/auth.service';
import { ConfigService } from '../../../Services/ConfigService';

@Component({
	selector: 'app-auth-callback',
	templateUrl: './auth-callback.component.html',
	styleUrls: ['./auth-callback.component.css'],
	
})
export class AuthCallbackComponent implements OnInit {

	error: boolean;

	constructor(private authService: AuthService,
		private configData: ConfigService,
		private route: ActivatedRoute) { }

	async ngOnInit() {

		// check for error
		if ((this.route?.snapshot?.fragment || '').indexOf('error') >= 0) {
			this.error = true;
			return;
		}
		var thisHolder = this;
		var toRedirect = setTimeout(() => {
			thisHolder.configData.goHome();
		}, 5 * 1000);
		try {
			this.authService.completeAuthentication().then(returnPath => {
				toRedirect = null;
				if (returnPath) {
					window.location.href = returnPath;
				} else {
					this.configData.goHome();
				}
			});
		} catch {
			this.configData.goHome();
		}
	}
}
